<template>
  <div 
    class="px-5 mt-12">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-dialog v-model="dialog.image"
            @keydown.esc="dialog.image = false"
            :fullscreen="dialog.fullscreen"
            width="600"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pa-4 text-right popup-header">
                <div
                  class="title font-weight-bold">
                  Ubah Gambar Tanda Tangan
                </div>

                <v-spacer/>

                <!-- <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon> -->

                <v-icon 
                  @click="dialog.image = false;"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/>

              <v-card-text 
                class="py-0 my-4">
                <uploadfolder
                  v-model="upload.image" 
                  style="height: 250px; width: 250px">
                  <div 
                    slot="activator"
                    class="cursor-pointer">
                    <v-card 
                      flat
                      height="250"
                      class="d-flex align-center justify-center"
                      style="border-radius: 15px;
                            border: 2px solid #eaeaea; 
                            border-style: dashed;">
                      <div v-if="img_ttd.length < 1">
                        <v-icon v-if="!process.image"
                          size="60" 
                          color="#4828a1">
                          mdi-cloud-upload-outline
                        </v-icon>

                        <v-progress-circular v-else
                          indeterminate
                          :color="set_color">
                        </v-progress-circular>
                      </div>

                      <v-img v-else
                        contain
                        height="250"
                        :src="img_ttd" 
                        :alt="img_ttd"
                        class="text-center d-flex align-center">
                        <div 
                          class="d-flex aling-center justify-center" 
                          style="width: 100%; height: auto;">
                          <v-icon v-if="!process.image"
                            size="60" 
                            color="white">
                            mdi-cloud-upload-outline
                          </v-icon>

                          <v-progress-circular v-else
                            indeterminate
                            :color="set_color">
                          </v-progress-circular>
                        </div>
                      </v-img>
                    </v-card>
                  </div>
                </uploadfolder>

                <div v-if="message.error.length > 0"
                  class="text-center mt-6">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
              </v-card-text>
              
              <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/>

              <v-card-actions
                class="pa-4">
                <v-spacer/>

                <v-btn
                  @click="saveImgtdd()"
                  :loading="process.form"
                  :disabled="process.form || img_ttd.length < 1"
                  width="120"
                  elevation="0"
                  color="green"
                  rounded
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Simpan
                </v-btn>

                <v-btn
                  @click="dialog.image = false;"
                  :disabled="process.form"
                  width="120"
                  outlined
                  elevation="0"
                  color="red"
                  rounded
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialog.status"
            @keydown.esc="dialog.status = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
              class="pa-8 pt-6">
              <v-card-title 
                class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
                
                Mengubah Status
  
                <v-spacer/>
  
                <!-- <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  color="#4828a1">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon> -->
  
                <v-icon 
                  @click="dialog.status = false; dialog.fullscreen = false; message.status = ''; message.error = ''"
                  class="cursor-pointer"
                  size="18"
                  color="#000000">
                  mdi-close
                </v-icon>
              </v-card-title>
              
              <!-- <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-text 
                class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
                Apakah Anda yakin mengubah status data menjadi <b class="font-weight-bold black--text">di{{ message.status }}</b> ?

                <div v-if="message.status === 'tolak'">
                  <ValidationObserver 
                    ref="form">
                    <v-form>

                      <div
                        class="mb-6 mt-5">
                        <ValidationProvider 
                          name="Alasan" 
                          rules="required" 
                          v-slot="{ errors }">
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Alasan
                          </div>

                          <v-textarea
                            v-on:keyup.enter="save()"
                            
                            filled
                            rounded
                            dense
                            rows="3"
                            solo

                            :color="set_color"
                            placeholder="Contoh. Tuliskan alasan disini . . ."


                            v-model="rejected_reason"
                            :error-messages="errors"
                            style="border-radius: 10px;">
                          </v-textarea>
                        </ValidationProvider>
                      </div>
                      
                    </v-form>
                  </ValidationObserver>
                </div>

                <div v-if="message.status === 'terima' && approved_by.length > 0">
                  <ValidationObserver 
                    ref="form">
                    <v-form>

                      <div
                        class="mb-6 mt-5">
                        <ValidationProvider 
                          name="Alasan" 
                          rules="required" 
                          v-slot="{ errors }">
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Alasan
                          </div>

                          <v-textarea
                            v-on:keyup.enter="save()"
                            
                            filled
                            rounded
                            dense
                            rows="3"
                            solo

                            :color="set_color"
                            placeholder="Contoh. Tuliskan alasan disini . . ."


                            v-model="approved_reason"
                            :error-messages="errors"
                            style="border-radius: 10px;">
                          </v-textarea>
                        </ValidationProvider>
                      </div>
                      
                    </v-form>
                  </ValidationObserver>
                </div>
  
                <div v-if="message.error.length > 0"
                  class="text-left mt-4">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="padding-top: 5px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
              </v-card-text>
  
  
              <!-- <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-actions
                class="pa-0 pt-4">
                <v-spacer/>
  
                <v-btn
                  rounded
                  @click="save()"
                  :loading="process.form"
                  :disabled="process.form"
                  width="190"
                  height="45"
                  elevation="0"
                  color="#6948c6"
                  class="fs-16 white--text text-capitalize border-radius">
                  Ya, {{ message.status }}
                </v-btn>
  
                <!-- <v-btn
                  rounded
                  width="120"
                  @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                  :disabled="process.status"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Batal
                </v-btn> -->
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialog.detail"
          @keydown.esc="dialog.detail = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
            class="pt-6">
            <v-card-title 
              class="d-flex align-center py-0 pb-4 text-right popup-header fs-20 font-weight-bold">
              
              Gambar Data

              <v-spacer/>

              <!-- <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#4828a1">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.detail = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon> -->

              <v-icon 
                @click="dialog.detail = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="18"
                color="#000000">
                mdi-close
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light pa-6 pt-0 text-first line-text-second my-0 py-3" v-if="Object.keys(detail).length > 0">
              <v-row>
                <!-- <v-col>
                  <div>
                    <div>
                      Nama Sales
                    </div>
                    <div class="fs-15 label-input">
                      {{ detail.sales_name }}
                    </div>
                  </div>
                  <div>
                    <div>
                      Nama Customer
                    </div>
                    <div class="fs-15 label-input">
                      {{ detail.customer_name }}
                    </div>
                  </div>
    
                  <div>
                    <div>
                      Nama Toko
                    </div>
                    <div class="fs-15 label-input">
                      {{ detail.store_name }}
                    </div>
                  </div>

                  <div>
                    <div>
                      Tipe
                    </div>
                    <div class="fs-15 label-input">
                      {{ detail.type }}
                    </div>
                  </div>

                  <div>
                    <div>
                      Catatan
                    </div>
                    <div class="fs-15 label-input">
                      {{ detail.note === '' ? '-' : detail.note }}
                    </div>
                  </div>

                </v-col> -->
                
                <v-col>

                  <div>
                    <div class="fs-15 label-input mt-3 text-center justify-center">
                      <v-img
                        contain
                        width="350"
                        height="350"
                        :src="detail.ttd" 
                        :alt="detail.ttd"
                        class="text-center d-flex align-center mx-auto">
                      </v-img>
                    </div>
                  </div>

                </v-col>
              </v-row>



              <div v-if="message.error.length > 0"
                class="text-center mt-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>


            <!-- <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-actions
              class="pa-6 pt-4">
              <v-spacer/>

              

              <!-- <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn> -->
            </v-card-actions>
          </v-card>
        </v-dialog>
          
          <div class="color-dark-blue fs-22 font-weight-bold">
            Detail Customer
          </div>

          <v-row>
            <v-col 
              cols="12"
              class="py-0 px-0">
              <v-card 
                flat
                min-height="calc(100vh - 245px)"
                style="border-radius: 25px; background-color: transparent;">
                <!-- <v-card-text
                  v-if="process.load" 
                  class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-2 title">
                      Mohon Tunggu...
                    </div>
                    <v-progress-circular
                      indeterminate
                    ></v-progress-circular>
                  </div>
                </v-card-text> -->

                <!-- <v-card-text v-if="!process.load && Object.keys(detail).length > 0"> -->
                  <!-- <div>
                    <v-tabs
                      v-model="tabs"
                      dense
                      background-color="transparent"
                      slider-size="5"
                      color="#6948c6">
                      <v-tab
                        v-for="(item, index) in tab"
                        :key="index"
                        v-on:change="changeQuery(item.link)">
                        <span
                          class="body-2 font-weight-medium text-capitalize">
                          {{ item.title }}
                        </span>
                      </v-tab>
                    </v-tabs>
                    <v-divider style="border-color: #EBEEF2;"></v-divider>
                  </div> -->

                  <div>

                    <v-row
                      class="pa-4">
                      <v-col 
                        cols="12"
                        class="py-0">
                        <v-card 
                          flat
                          min-height="calc(100vh - 245px)">

                          <v-card-text
                            v-if="Object.keys(detail).length < 1" 
                            class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                            <div class="text-center">
                              <div class="mb-2 title">
                                Mohon Tunggu...
                              </div>
                              <v-progress-circular
                                indeterminate
                              ></v-progress-circular>
                            </div>
                          </v-card-text>

                          <v-card-text v-if="Object.keys(detail).length > 0">
                            <v-row>
                              <v-col cols="12" md="6" class="py-0">
                                <table>
                                  <tr>
                                    <td>
                                      Nama
                                    </td>
                                    <td style="width: 60px" class="text-right py-1 pr-1">
                                      : 
                                    </td>
                                    <td class="fs-16 label-input">
                                      {{ detail.name }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      Nama Alias
                                    </td>
                                    <td style="width: 60px" class="text-right py-1 pr-1">
                                      : 
                                    </td>
                                    <td class="fs-16 label-input">
                                      {{ detail.name_alias }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      NIK
                                    </td>
                                    <td style="width: 60px" class="text-right py-1 pr-1">
                                      : 
                                    </td>
                                    <td class="fs-16 label-input">
                                      {{ detail.nik }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      Email
                                    </td>
                                    <td style="width: 60px" class="text-right py-1 pr-1">
                                      : 
                                    </td>
                                    <td class="fs-16 label-input">
                                      {{ detail.email === '' ? '-' : detail.email }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      Tempat, tanggal lahir
                                    </td>
                                    <td style="width: 60px" class="text-right py-1 pr-1">
                                      : 
                                    </td>
                                    <td class="fs-16 label-input">
                                      <span v-if="detail.birthplace === '' && detail.birthdate === ''">
                                      -
                                    </span>
                                    <span v-else>
                                      {{ detail.birthplace }}, {{ detail.birthdate | date }}
                                    </span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      NPWP
                                    </td>
                                    <td style="width: 60px" class="text-right py-1 pr-1">
                                      : 
                                    </td>
                                    <td class="fs-16 label-input">
                                      {{ detail.npwp === '' ? '-' : detail.npwp }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      Agama
                                    </td>
                                    <td style="width: 60px" class="text-right py-1 pr-1">
                                      : 
                                    </td>
                                    <td class="fs-16 label-input">
                                      {{ detail.religion !== '' ? detail.religion : '-'}}
                                    </td>
                                  </tr>

                                  <tr>
                                    <td>
                                      No. Phone 1
                                    </td>
                                    <td style="width: 60px" class="text-right py-1 pr-1">
                                      : 
                                    </td>
                                    <td class="fs-16 label-input">
                                      <span v-if="detail.mobilephone_arr.length < 1">
                                        -
                                      </span>
                                      <span v-else>
                                        {{ detail.mobilephone_arr[0] }}
                                      </span>
                                    </td>
                                  </tr>

                                  <tr>
                                    <td>
                                      No. Phone 2
                                    </td>
                                    <td style="width: 60px" class="text-right py-1 pr-1">
                                      :
                                    </td>
                                    <td class="fs-16 label-input">
                                      <span v-if="detail.mobilephone_arr.length < 2">
                                        -
                                      </span>
                                      <span v-else>
                                        {{ detail.mobilephone_arr[1] }}
                                      </span>
                                    </td>
                                  </tr>

                                  <tr>
                                    <td>
                                      Whatsapp
                                    </td>
                                    <td style="width: 60px" class="text-right py-1 pr-1">
                                      :
                                    </td>
                                    <td class="fs-16 label-input">
                                      <span v-if="detail.mobilephone_arr.length < 3">
                                        -
                                      </span>
                                      <span v-else>
                                        {{ detail.mobilephone_arr[2] }}
                                      </span>
                                    </td>
                                  </tr>

                                </table>
                                <!-- <div>
                                  <div 
                                    class="fs-14">
                                    Nama
                                  </div>
                                  <div class="fs-16 label-input">
                                    {{ detail.name }}
                                  </div>
                                </div>

                                <div>
                                  <div 
                                    class="fs-14">
                                    Nama Alias
                                  </div>
                                  <div class="fs-16 label-input">
                                    {{ detail.name_alias }}
                                  </div>
                                </div>

                                <div>
                                  <div 
                                    class="fs-14">
                                    NIK
                                  </div>
                                  <div class="fs-16 label-input">
                                    {{ detail.nik }}
                                  </div>
                                </div>

                                <div>
                                  <div 
                                    class="fs-14">
                                    Email
                                  </div>
                                  <div class="fs-16 label-input">
                                    {{ detail.email }}
                                  </div>
                                </div>


                                <div>
                                  <div 
                                    class="fs-14">
                                    Tempat, tanggal lahir
                                  </div>
                                  <div class="fs-16 label-input">
                                    <span v-if="detail.birthplace === '' && detail.birthdate === ''">
                                      -
                                    </span>
                                    <span v-else>
                                      {{ detail.birthplace }}, {{ detail.birthdate | date }}
                                    </span>
                                  </div>
                                </div> -->

                                <!-- <div>
                                  <div 
                                    class="fs-14">
                                    NPWP
                                  </div>
                                  <div class="fs-16 label-input">
                                    {{ detail.npwp }}
                                  </div>
                                </div> -->
                  
                                <!-- <div>
                                  <div 
                                    class="fs-14">
                                    Agama
                                  </div>
                                  <div class="fs-16 label-input">
                                    {{ detail.religion !== '' ? detail.religion : '-'}}
                                  </div>
                                </div> -->

                  
                                <div>
                                  <div 
                                    class="fs-14">
                                    <!-- <span class="red--text">*</span> -->
                                    Alamat
                                  </div>
                                  <div class="fs-16 label-input text-lowercase">
                                    {{ detail.address }}, {{ detail.village_name !== '' ? detail.village_name : '-'}}, {{ detail.subdistrict_name !== '' ? detail.subdistrict_name : '-'}}, {{ detail.city_name !== '' ? detail.city_name : '-'}} - {{ detail.province_name !== '' ? detail.province_name : '-'}}
                                  </div>
                                </div>

                                <div>
                                  <div 
                                    class="fs-14">
                                    <!-- <span class="red--text">*</span> -->
                                    Tanda Tangan
                                  </div>
                                  <div>
                                    <v-btn
                                      elevation="0"
                                      :color="`orange`"
                                      class="body-2 font-weight-bold text-capitalize white--text mt-2 mb-1"
                                      style="border-radius: 10px;"
                                      @click="img_ttd = ''; dialog.image = true; message.error = '';">
                                      Ubah Tanda Tangan
                                    </v-btn>
                                  </div>
                                  <div class="fs-16 label-input">
                                    <div style="border: 1px solid #DFEAF2; border-radius: 15px; width: 250px;" class="mt-2" @click="dialog.detail = true">
                                      <!-- <div class="mb-3 fs-14">
                                        Perbesar Gambar:
                                        <v-btn @click="$refs.zoomerttd.zoomIn()" small color="blue" class="body-2 white--text text-capitalize ml-2" style="border-radius: 10px;">
                                          <v-icon 
                                            size="20">
                                            mdi-plus
                                          </v-icon>
                                        </v-btn>
                                        <v-btn @click="$refs.zoomerttd.zoomOut()" :disabled="!zoomedTtd" small color="warning" class="body-2 white--text text-capitalize ml-4" style="border-radius: 10px;">
                                          <v-icon 
                                            size="20">
                                            mdi-minus
                                          </v-icon>
                                        </v-btn>
                                      </div> -->
                                      <v-img
                                        :src="detail.ttd"
                                        contain
                                        width="250"
                                        height="150"
                                        >
                                      </v-img>
                                      <!-- <v-zoomer
                                        ref="zoomerttd"
                                        style="width: 100%; height: 250px; border: solid 1px silver;"
                                        :aspect-ratio="imageAspectRatioTtd"
                                        :max-scale="10"
                                        :zooming-elastic="false"
                                        :zoomed.sync="zoomedTtd"
                                      >
                                        <img :src="detail.ttd" style="object-fit: contain; width: 100%; height: 100%;" @load="onImageLoadAkta">
                                      </v-zoomer> -->
                                    </div>
                                  </div>
                                </div>
                              </v-col>
                              <v-col cols="12" md="6" class="py-0" style="border-left: 1px solid #eee;">
                                <table>
                                  <tr>
                                    <td>
                                      Plafon
                                    </td>
                                    <td style="width: 60px" class="text-right py-1 pr-1">
                                      :
                                    </td>
                                    <td class="fs-16 label-input">
                                      Rp. {{ detail.plafon | pricing }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      Faktur
                                    </td>
                                    <td style="width: 60px" class="text-right py-1 pr-1">
                                      :
                                    </td>
                                    <td class="fs-16 label-input">
                                      {{ detail.faktur }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      TOP
                                    </td>
                                    <td style="width: 60px" class="text-right py-1 pr-1">
                                      :
                                    </td>
                                    <td class="fs-16 label-input">
                                      {{ detail.term }} Hari
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      Sales Register
                                    </td>
                                    <td style="width: 60px" class="text-right py-1 pr-1">
                                      :
                                    </td>
                                    <td class="fs-16 label-input">
                                      {{ detail.reg_by }}
                                    </td>
                                  </tr>
                                </table>

                                <!-- <div>
                                  <div 
                                    class="fs-14">
                                    Plafon
                                  </div>
                                  <div class="fs-16 label-input">
                                    Rp. {{ detail.plafon | pricing }}
                                  </div>
                                </div>

                                <div>
                                  <div 
                                    class="fs-14">
                                    Faktur
                                  </div>
                                  <div class="fs-16 label-input">
                                    {{ detail.faktur }}
                                  </div>
                                </div>

                                <div>
                                  <div 
                                    class="fs-14">
                                    TOP
                                  </div>
                                  <div class="fs-16 label-input">
                                    {{ detail.term }} Hari
                                  </div>
                                </div>
                                <div>
                                  <div 
                                    class="fs-14">
                                    Sales Register
                                  </div>
                                  <div class="fs-16 label-input">
                                    {{ detail.reg_by }}
                                  </div>
                                </div> -->
                                <div>
                                  <div 
                                    class="fs-14 mt-1">
                                    <!-- <span class="red--text">*</span> -->
                                    Peta Lokasi
                                  </div>
                                  <div class="fs-16 label-input">
                                    <div v-if="detail.latitude === ''">
                                      -
                                    </div>
                                    <div class="mt-2" v-if="detail.latitude !== ''">
                                      <!-- <a 
                                      :href="`https://www.google.com/maps/search/?api=1&query=${detail.latitude},${detail.longitude}`"
                                      style="color:#0000FF;text-align:left" 
                                        target="_blank"> -->
                                          <!-- <iframe 
                                            width="100%" 
                                            height="250" 
                                            frameborder="0" 
                                            scrolling="no" 
                                            marginheight="0" 
                                            marginwidth="0" 
                                            :src="`https://maps.google.com/maps?q=${detail.latitude},${detail.longitude}&hl=es&z=14&amp;output=embed`"
                                            >
                                          </iframe> -->

                                          <gmap-map
                                            :center="center"
                                            :zoom="16"
                                            :options="{
                                              zoomControl: true,
                                              mapTypeControl: false,
                                              scaleControl: false,
                                              streetViewControl: false,
                                              rotateControl: false,
                                              fullscreenControl: true,
                                              disableDefaultUi: false
                                            }"
                                            style="width: 100%; height: 250px;">

                                            <gmap-marker
                                              :position="center">
                                            </gmap-marker>
                                          </gmap-map>
                                        <!-- </a> -->
                                      </div>
                                  </div>
                                </div>
                  
                                <div v-if="Object.keys(visit).length > 0">
                                  <div 
                                    class="fs-14" mt-2>
                                    <!-- <span class="red--text">*</span> -->
                                    Peta Lokasi Registrasi
                                  </div>
                                  <div class="fs-16 label-input">
                                    <div v-if="visit.latitude === ''">
                                      -
                                    </div>
                                    <div class="mt-2" v-if="visit.latitude !== '' && visit.latitude !== undefined">
                                      <!-- <a 
                                      :href="`https://www.google.com/maps/search/?api=1&query=${visit.latitude},${visit.longitude}`"
                                      style="color:#0000FF;text-align:left" 
                                        target="_blank"> -->
                                          <!-- <iframe 
                                            width="100%" 
                                            height="250" 
                                            frameborder="0" 
                                            scrolling="no" 
                                            marginheight="0" 
                                            marginwidth="0" 
                                            :src="`https://maps.google.com/maps?q=${visit.latitude},${visit.longitude}&hl=es&z=14&amp;output=embed`"
                                            >
                                          </iframe> -->
                                          <gmap-map
                                            :center="center_visit"
                                            :zoom="16"
                                            :options="{
                                              zoomControl: true,
                                              mapTypeControl: false,
                                              scaleControl: false,
                                              streetViewControl: false,
                                              rotateControl: false,
                                              fullscreenControl: true,
                                              disableDefaultUi: false
                                            }"
                                            style="width: 100%; height: 250px;">

                                            <gmap-marker
                                              :position="center_visit">
                                            </gmap-marker>
                                          </gmap-map>
                                        <!-- </a> -->
                                      </div>
                                  </div>
                                </div>
                              </v-col>
                              <v-col cols="12" md="4" class="py-0">

                                
                              </v-col>
                            </v-row>

                            <div v-if="message.error.length > 0"
                              class="text-center my-4 d-flex align-center">
                              <div
                                class="error--text">
                                <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                                
                                <span
                                  class="ml-1">
                                  {{ message.error }}
                                </span>
                              </div>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>

                    <!-- <Visit v-if="tabs === 2" :detail="detail" /> -->

                    <Toko  :detail="detail" />
                    <Approval  :detail="detail" @approved="approved_by = $event" />

                  </div>


                  <!-- <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div> -->
                <!-- </v-card-text> -->
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">

              <div
                v-if="!process.load && detail.status === 'proses'">

                <div
                  v-if="user.category_user_title === 'Supervisor' && detail.approved_supervisor_id === '0'"
                  class="d-flex align-center">
                  <v-btn 
                    @click="dialog.status = true; message.error = ''; message.status = 'terima'; approved_reason = ''"
                    :loading="process.load"
                    :disabled="process.load"
                    width="150"
                    height="45"
                    elevation="0"
                    color="#6948c6"
                    class="fs-16 white--text text-capitalize border-radius">
                    Diterima
                  </v-btn>
    
                  <v-btn
                    @click="message.error = ''; rejected_reason = ''; dialog.status = true; message.error = ''; message.status = 'tolak'"
                    :loading="process.load"
                    :disabled="process.load"
                    width="120"
                    height="45"
                    elevation="0"
                    color="warning"
                    class="fs-16 ml-4 white--text text-capitalize border-radius">
                    Ditolak
                  </v-btn>
                </div>

                <div
                  v-else-if="user.category_user_title === 'Sales Manager' && detail.approved_sales_manager_id === '0'"
                  class="d-flex align-center">
                  <v-btn 
                    @click="dialog.status = true; message.error = ''; message.status = 'terima'; approved_reason = ''"
                    :loading="process.load"
                    :disabled="process.load"
                    width="150"
                    height="45"
                    elevation="0"
                    color="#6948c6"
                    class="fs-16 white--text text-capitalize border-radius">
                    Diterima
                  </v-btn>
    
                  <v-btn
                    @click="message.error = ''; rejected_reason = ''; dialog.status = true; message.error = ''; message.status = 'tolak'"
                    :loading="process.load"
                    :disabled="process.load"
                    width="120"
                    height="45"
                    elevation="0"
                    color="warning"
                    class="fs-16 ml-4 white--text text-capitalize border-radius">
                    Ditolak
                  </v-btn>
                </div>
                
                <div
                  v-else-if="user.category_user_title === 'General Manager' && detail.approved_gm_id === '0'"
                  class="d-flex align-center">
                  <div v-if="detail.approved_sales_manager_id === '0' && detail.approved_supervisor_id === '0'">
                    <v-btn 
                      @click="dialog.status = true; message.error = ''; message.status = 'terima'; approved_reason = ''"
                      :loading="process.load"
                      :disabled="process.load"
                      elevation="0"
                      v-if="approved_by.filter(item => item === 'Sales Manager').length > 0"
                      color="#6948c6"
                      :width="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 150"
                      :height="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 45"
                      :class="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 'border-radius'"
                      class="fs-16 white--text text-capitalize">
                      Diterima
                    </v-btn>
                  </div>
                  <div v-if="detail.approved_sales_manager_id !== '0' && detail.approved_supervisor_id === '0'">
                    <v-btn 
                      @click="dialog.status = true; message.error = ''; message.status = 'terima'; approved_reason = ''"
                      :loading="process.load"
                      :disabled="process.load"
                      elevation="0"
                      v-if="approved_by.filter(item => item === 'Supervisor').length > 0"
                      color="#6948c6"
                      :width="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 150"
                      :height="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 45"
                      :class="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 'border-radius'"
                      class="fs-16 white--text text-capitalize">
                      Diterima
                    </v-btn>
                  </div>
                  <div v-if="detail.approved_sales_manager_id === '0' && detail.approved_supervisor_id !== '0'">
                    <v-btn 
                      @click="dialog.status = true; message.error = ''; message.status = 'terima'; approved_reason = ''"
                      :loading="process.load"
                      :disabled="process.load"
                      elevation="0"
                      v-if="approved_by.filter(item => item === 'Sales Manager').length > 0"
                      color="#6948c6"
                      :width="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 150"
                      :height="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 45"
                      :class="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 'border-radius'"
                      class="fs-16 white--text text-capitalize">
                      Diterima
                    </v-btn>
                  </div>
                  <div v-if="detail.approved_sales_manager_id !== '0' && detail.approved_supervisor_id !== '0'">
                    <v-btn 
                      @click="dialog.status = true; message.error = ''; message.status = 'terima'; approved_reason = ''"
                      :loading="process.load"
                      :disabled="process.load"
                      elevation="0"
                      color="#6948c6"
                      :width="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 150"
                      :height="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 45"
                      :class="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 'border-radius'"
                      class="fs-16 white--text text-capitalize">
                      Diterima
                    </v-btn>
                  </div>
    
                  <v-btn
                    @click="message.error = ''; rejected_reason = ''; dialog.status = true; message.error = ''; message.status = 'tolak'"
                    :loading="process.load"
                    :disabled="process.load"
                    elevation="0"
                    color="warning"
                    :width="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 150"
                    :height="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 45"
                    :class="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 'border-radius'"
                    class="fs-16 white--text ml-3 text-capitalize">
                    Ditolak
                  </v-btn>  
                </div>
              </div>

              
              <v-btn
                @click="$router.go(-1)"
                color="red"
                elevation="0"
                :width="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 150"
                :height="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 45"
                :class="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 'border-radius'"
                class="fs-16 white--text ml-3 text-capitalize">
              
                  Kembali
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        rejected_reason: '',
        tabs: 0,
        tab: [
          {
            title: 'Toko',
            link: `/customer/data/detail/${this.$route.params.id}?menu=toko`
          },
          {
            title: 'Profil',

            link: `/customer/data/detail/${this.$route.params.id}?menu=detail`
          },
          // {
          //   title: 'Jadwal Visit',
          //   link: `/customer/data/detail/${this.$route.params.id}?menu=visit`
          // },
          {
            title: 'Approval',
            link: `/customer/data/detail/${this.$route.params.id}?menu=approval`
          }
        ],
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        modal: false,
        menu2: false,
        
        zoomed: false,
        zoomedTtd: false,
        imageAspectRatio: 1,
        imageAspectRatioTtd: 1,
        approved_by: [],
        approved_reason: '',


        dialog: {
          status: false,
          image: false,
          fullscreen: false,
          detail: false
        },

        detail: {},
        selected: {
          img: ''
        },

        form: {
          id: '',
          sales_id: '',
          name_alias: '',
          name: '',
          mobilephone_arr: [],
          email: '',
          nik: '',
          npwp: '',
          plafon: '',
          faktur: '',
          term: '',
          ttd: ''
        },
        category: [],
        branch: [],

        mobilephone: {
          name: '',
          id: ''
        },

        upload: {
          // ttd: null,
          // image_url: null,
          image: null
        },
        // dialog: {
        //     image: false,
        //     fullscreen: false
        //   },
        //   date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        //   menu: false,
        //   modal: false,
        //   menu2: false,
        img_ttd: '',
        sales: {},
        visit: {},
        center: {
          lat: 0,
          lng: 0
        },
        center_visit: {
          lat: 0,
          lng: 0
        },

        process: {
          form: false,

          load: false,

          image_url: false,
          image: false,
        },
        
        message: {
          success: '',
          error: '',
          status: ''
        }
      }
    },
    components: {
      Detail: () => import(/* webpackPrefetch: true */ '@/components/customer/detail.vue'),
      Approval: () => import(/* webpackPrefetch: true */ '@/components/customer/approval.vue'),
      Toko: () => import(/* webpackPrefetch: true */ '@/components/customer/toko.vue'),
      uploadfolder: () => import('@/components/upload/folder.vue')
    },
    watch: {
      'upload.image': {
        handler: function () {
          if (this.upload.image) {
            this.process.image = this.upload.image.process

            if (!this.process.image) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.img_ttd = this.upload.image.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      },
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchDetail()
      // this.changeLink(this.$route.query.menu)
    },
    methods: {
      async fetchDetail () {
        this.detail = {}
        this.process.load = true
        let params = {
          id: this.$route.params.id
        }

        await get('admin/customer/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            
            this.detail = res.results.data
            this.detail.store.map(item => {
              item.store_images = item.store_images.length > 0 ? JSON.parse(item.store_images) : []
            })
            this.detail.mobilephone_arr = this.detail.mobilephone_arr.length > 0 ? JSON.parse(this.detail.mobilephone_arr) : []
            this.detail.approved_reason = this.detail.approved_reason.length < 1 ? { name: '', reason: '' } : JSON.parse(this.detail.approved_reason)
            this.fetchSales()
          }
          this.process.load = false
        })
      },
      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.rejected_reason = ''

        this.approved_by = []

        this.process.form = false

        this.message.error = ''
      },
      onImageLoad(e) {
        const img = e.target
        this.imageAspectRatio = img.naturalWidth / img.naturalHeight
      },
      onImageLoadAkta(e) {
        const img = e.target
        this.imageAspectRatioAkta = img.naturalWidth / img.naturalHeight
      },
      async fetchSales () {
          this.process.load = true

          let params = {
          limit: 10000000000000,

          'category_user_id[eq]': '8',
          name: this.detail.reg_by
        }

        await get(`admin/user/data`, { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
              this.sales = res.results.data[0]

              this.center = {
                lat: (this.detail.latitude)*1,
                lng: (this.detail.longitude)*1
              }
              
            }
            this.fetchVisit(this.sales.id)
            this.process.load = false
          })
        },
        async fetchVisit (id) {
          this.process.load = true

          let params = {
          limit: 10000000000000,
          sales_id: id,
          customer_id: this.$route.params.id,
          type: 'NOO'
        }

        await get(`admin/visit/data`, { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
              this.visit = res.results.data.length > 0 ? res.results.data[0] : {}
              if(res.results.data.length > 0) {
                this.center_visit = {
                  lat: (this.visit.latitude)*1,
                  lng: (this.visit.longitude)*1
                }
              }
              // this.center_visit = {
              //   lat: (this.visit.latitude)*1,
              //   lng: (this.visit.longitude)*1
              // }
              
            }
            this.process.load = false
          })
        },
        async saveImgtdd () {
          this.message.error = ''

          this.process.form = true

          await post(`admin/customer/update`, { data: 
            {
              id: this.detail.id,
              ttd: this.img_ttd
            }
          })
          .then(response => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {
              this.fetchDetail()
              this.upload.image = null

              this.dialog.image = false
              this.dialog.snackbar = true
              this.message.success = res.message
              this.message.error = ''
            } else {
              this.message.error = res.message
            }
          })
        },

      changeLink (query) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
        
        if (query !== undefined) {
          this.tabs = query === 'detail' ? 1 : query === 'approval' ? 2 : 0
        } else {
          this.tabs = 0
        this.$router.push(this.tab[this.tabs].link)
        }
      },
      changeQuery (link) {
        this.$router.push(link)
      },

      async save () {
        this.message.error = ''
        const isValid = this.message.status === 'terima' ? this.approved_by.length > 0 ? await this.$refs.form.validate() : true : await this.$refs.form.validate()
        if (isValid) {
          

        this.process.form = true
        let approved_reason = {
          name: '',
          reason: ''
        }
        if (this.message.status === 'terima') {
          if(this.approved_by.length === 1 && this.approved_by[0] === 'Supervisor') {

            approved_reason = {
              name: 'Supervisor',
              reason: this.approved_reason
            }
          } else if(this.approved_by.length === 1 && this.approved_by[0] === 'Sales Manager') {
            approved_reason = {
              name: 'Sales Manager',
              reason: this.approved_reason
            }
          } else if(this.approved_by.length > 1) {
            approved_reason = {
              name: 'all',
              reason: this.approved_reason
            }
          } 
        }

        await post(`admin/customer/approval`, {
          data: {
            customer_id: this.detail.id,
            status: this.message.status === 'terima' ? 'approved' : 'rejected',
            approved_by: this.message.status === 'terima' ? this.approved_by.length < 1 ? this.user.category_user_title === 'General Manager' ?  this.user.category_user_title : this.user.category_user_title : this.approved_by.length === 1 ? `${this.approved_by[0]},General Manager` : `Supervisor,Sales Manager,General Manager` : '',
            approved_reason: approved_reason.reason,
            rejected_reason: this.rejected_reason
          }
        }).then(response => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {

            this.dialog.status = false

            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetchDetail()
          } else {
            this.message.error = res.message
          }
        })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>